import { createContext } from "react"

const ClassificationsContext = createContext();

export default ClassificationsContext;